import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

import './sidenavitem.scss';
import SideNavItemChild from './SideNavItemChild';

const SideNavItem = ({ menuItem, closeMenu }) => {
  const [renderChildren, setRenderChildren] = useState(false);
  const location = useLocation();
  const isActive = () => {
    return location.pathname === menuItem.url;
  };

  if (!menuItem.hasChildren) {
    const isExternal = menuItem.url && menuItem.url.startsWith('http');
    const content = (
      <div className={`side-nav-item m-auto d-flex align-items-center px-3 ${isActive() ? 'active' : ''} ${menuItem.customClass || ''}`}>
        <i className={`fa ${menuItem.iconClass}`}></i>
        <span className="text-nowrap">{menuItem.title}</span>
      </div>
    );

    return (
      <div onClick={closeMenu}>
        {isExternal ? (
          <a href={menuItem.url} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
            {content}
          </a>
        ) : (
          <Link to={menuItem.url} onClick={event => (menuItem.onClick && menuItem.onClick(event))} className="text-decoration-none">
            {content}
          </Link>
        )}
      </div>
    );
  }

  return (
    <>
      <div
        onClick={() => setRenderChildren(!renderChildren)}
        className={`side-nav-item m-auto d-flex flex-col cursor-pointer align-items-center px-3`}
      >
        <i className={`fa ${menuItem.iconClass}`}></i>
        <span className="text-nowrap">{menuItem.title}</span>
        <i className={`fa fa-chevron-down ml-auto ${renderChildren ? `invert` : ``}`} />
      </div>
      {renderChildren && (
        menuItem.children.map((child, i) => (
          <SideNavItemChild key={i} menuItem={child} />
        ))
      )}
    </>
  );
};

export default SideNavItem;
